import { createSelector } from 'reselect';

import type { RootState } from '@/types/store/common';

export const getIsMobileScreen = createSelector(
  (state: RootState) => state.core.windowWidth,
  windowWidth => windowWidth < 576
);
